export default {"src":"/_next/static/media/flora.00603425.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};